import update from 'immutability-helper'
import {
  FETCH_PROPOSAL_SUB_STATIONS,
  FETCH_CATEGORIES_BY_SUB_STATIONS,
  FETCH_RECENTLY_CATEGORY_OPTIONS
} from '../actions/actionTypes'

const initialState = {
  subStations: [],
  subStationCategories: [],
  recentlyCategoryOptions: []
}

const serviceErrorReducer = (state, action) => {
  // service fail

  switch (action.type) {
    default:
      return state
  }
}

const serviceReducer = (state, action) => {
  // service error
  if (action.error) {
    return serviceErrorReducer(state, action)
  }

  switch (action.type) {
    case FETCH_PROPOSAL_SUB_STATIONS: {
      return update(state, { subStations: { $set: action.payload } })
    }
    case FETCH_CATEGORIES_BY_SUB_STATIONS: {
      return update(state, { subStationCategories: { $set: action.payload } })
    }
    case FETCH_RECENTLY_CATEGORY_OPTIONS: {
      return update(state, { recentlyCategoryOptions: { $set: action.payload } })
    }
    default:
      return state
  }
}

const finalReducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROPOSAL_SUB_STATIONS:
    case FETCH_CATEGORIES_BY_SUB_STATIONS:
    case FETCH_RECENTLY_CATEGORY_OPTIONS:
      return serviceReducer(state, action)

    default:
      return state
  }
}

export default finalReducers
